export const errorContainerStyles = {
    p: '24px',
};

export const errorAlertStyles = {
    alignItems: 'flex-start',
    '& .MuiAlert-message': {
        width: '100%',
        py: 0.25,
    },
    '& .MuiAlert-action': {
        pt: 0.25,
        pl: 2,
        mr: 0,
        alignSelf: 'flex-start',
    },
};

export const errorRetryButtonStyles = {
    whiteSpace: 'nowrap',
    fontWeight: 600,
};

export const errorContentStyles = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
};

export const errorTypeChipStyles = {
    alignSelf: 'flex-start',
    fontWeight: 600,
    fontSize: '0.75rem',
    borderColor: 'error.dark',
    color: 'error.dark',
};

export const errorMessageStyles = {
    lineHeight: 1.5,
};

export const errorSuggestionsContainerStyles = {
    mt: 2,
};

export const errorSuggestionsTitleStyles = {
    fontWeight: 600,
    mb: 0.75,
};

export const errorSuggestionsListStyles = {
    m: 0,
    pl: 2.5,
    '& li': { mb: 0.5 },
};

export const errorSuggestionItemStyles = {
    lineHeight: 1.5,
};
